import { inject } from "@angular/core";
import { CanActivateFn, UrlTree, Router, ActivatedRouteSnapshot } from "@angular/router";

import { Observable, map } from "rxjs";

import { AuthenticationService, ExtensionsService } from "../services";

export const EnabledExtensionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const authenticationService = inject(AuthenticationService);
  const extensionsService = inject(ExtensionsService);
  const router = inject(Router);
  const defaultRoute = authenticationService.getDefaultRoute();

  return extensionsService
    .getAllEnabledObservable(authenticationService.getActiveOrganisationId())
    .pipe(
      map(
        (enabledExtensions: string[]) =>
          enabledExtensions.includes(route.data["extensionProvider"]) ||
          router.createUrlTree([`/${defaultRoute}`]),
      ),
    );
};
